/* A Biomedical Service, vertical facet enhancement
   Adds a "Search options" box + scrollable list to any filter group with many
   options (e.g. Category, Brand), matching the desired filter UI. Re-applies
   after Dawn's AJAX facet re-render. Pure progressive enhancement. */
(function () {
  var THRESHOLD = 8;   /* show the search box once a group has more options than this */
  var MAX_HEIGHT = 165; /* px, scrollable list height (~5 rows, like the live site) */

  function injectStyles() {
    if (document.getElementById('abio-facet-search-styles')) return;
    var s = document.createElement('style');
    s.id = 'abio-facet-search-styles';
    s.textContent =
      '.abio-facet-search{padding:.2rem 0 1rem}' +
      '.abio-facet-search__input{width:100%;box-sizing:border-box;padding:.9rem 1.2rem;' +
        'font-size:1.4rem;line-height:1.2;border:1px solid rgba(11,25,41,.25);border-radius:6px;' +
        'background:#fff;color:#0B1929;outline:none}' +
      '.abio-facet-search__input:focus{border-color:#0E84B4;box-shadow:0 0 0 2px rgba(40,191,246,.25)}' +
      '.abio-facet-search__input::placeholder{color:#6A7682}' +
      'ul.abio-facet-scroll{max-height:' + MAX_HEIGHT + 'px;overflow-y:auto;padding-right:.4rem}' +
      '.abio-facet-hidden{display:none !important}';
    document.head.appendChild(s);
  }

  function enhance(details) {
    /* open every group by default (once per element, so a user collapse sticks) */
    if (!details.dataset.abioInit) {
      details.dataset.abioInit = '1';
      details.open = true;
    }
    var list = details.querySelector('ul.facets__list--vertical') || details.querySelector('ul.facets__list');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('li.facets__item'));

    /* ALL groups: reveal every option (override show-more) + cap height to ~5 rows w/ scroll */
    items.forEach(function (li) { li.classList.remove('hidden'); });
    list.classList.add('abio-facet-scroll');
    var moreBtn = details.querySelector('show-more-button');
    if (moreBtn) moreBtn.style.display = 'none';

    /* large groups only: add the "Search options" box */
    if (items.length <= THRESHOLD) return;
    if (details.querySelector('.abio-facet-search')) return;

    var wrap = document.createElement('div');
    wrap.className = 'abio-facet-search';
    var input = document.createElement('input');
    input.type = 'search';
    input.placeholder = 'Search options';
    input.className = 'abio-facet-search__input';
    input.setAttribute('autocomplete', 'off');
    wrap.appendChild(input);
    list.parentNode.insertBefore(wrap, list);

    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      items.forEach(function (li) {
        var labelEl = li.querySelector('.facet-checkbox__text-label');
        var text = (labelEl ? labelEl.textContent : li.textContent).toLowerCase();
        li.classList.toggle('abio-facet-hidden', q.length > 0 && text.indexOf(q) === -1);
      });
    });
  }

  function splitCounts(root) {
    (root || document).querySelectorAll('.facets-vertical .facet-checkbox__text').forEach(function (txt) {
      if (txt.dataset.abioCount) return;
      var label = txt.querySelector('.facet-checkbox__text-label');
      if (!label) return;
      var m = txt.textContent.match(/\(([\d,]+)\)\s*$/);
      if (!m) return;
      txt.dataset.abioCount = '1';
      while (label.nextSibling) txt.removeChild(label.nextSibling); // drop the " (N)" text node
      var c = document.createElement('span');
      c.className = 'abio-count';
      c.textContent = m[1];
      txt.appendChild(c);
    });
  }

  function run() {
    injectStyles();
    splitCounts(document);
    document.querySelectorAll('details.facets__disclosure-vertical').forEach(enhance);
  }

  function init() {
    run();
    var container = document.getElementById('FacetFiltersForm') || document.body;
    new MutationObserver(function () { run(); }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
